// testProfileAnalyticsChart.jsx

import React, { useMemo } from "react";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  BarChart,
  Bar,
} from "recharts";

const TestProfileAnalyticsChart = ({ data }) => {
  const { revenueChartData, bookingChartData } = useMemo(() => {
    if (!Array.isArray(data)) {
      return {
        revenueChartData: [],
        bookingChartData: [],
      };
    }

    const revenueGrouped = {};

    const bookingGrouped = {};

    data.forEach((item) => {
      if (!item.appointmentDate) return;

      const date = new Date(item.appointmentDate).toLocaleDateString("en-CA");

      if (!revenueGrouped[date]) {
        revenueGrouped[date] = {
          name: date,
          revenue: 0,
        };
      }

      if (!bookingGrouped[date]) {
        bookingGrouped[date] = {
          name: date,
          bookings: 0,
        };
      }

      revenueGrouped[date].revenue += parseFloat(item.totalAmount) || 0;

      bookingGrouped[date].bookings += 1;
    });

    return {
      revenueChartData: Object.values(revenueGrouped).sort(
        (a, b) => new Date(a.name) - new Date(b.name),
      ),

      bookingChartData: Object.values(bookingGrouped).sort(
        (a, b) => new Date(a.name) - new Date(b.name),
      ),
    };
  }, [data]);

  if (!revenueChartData.length && !bookingChartData.length) {
    return (
      <div
        style={{
          minHeight: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "600",
        }}
      >
        No analytics data available
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(450px,1fr))",
        gap: "1rem",
      }}
    >
      {/* Revenue Trend */}

      <div
        style={{
          background: "#fff",
          borderRadius: "1rem",
          padding: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        <h3
          style={{
            marginBottom: "1rem",
          }}
        >
          Revenue Trend
        </h3>

        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={revenueChartData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="name" />

            <YAxis />

            <Tooltip />

            <Legend />

            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#5921cf"
              strokeWidth={3}
              name="Revenue"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Booking Trend */}

      <div
        style={{
          background: "#fff",
          borderRadius: "1rem",
          padding: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        <h3
          style={{
            marginBottom: "1rem",
          }}
        >
          Booking Trend
        </h3>

        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={bookingChartData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="name" />

            <YAxis />

            <Tooltip />

            <Legend />

            <Bar
              dataKey="bookings"
              fill="#16a34a"
              name="Bookings"
              radius={[6, 6, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TestProfileAnalyticsChart;
